import React, {useState} from 'react';
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import {Col, Row} from "react-bootstrap";
import LeftEvents from "./LeftEvents";
import {Carousel} from "react-responsive-carousel";
import styles from "react-responsive-carousel/lib/styles/carousel.min.css";
import {Link} from "react-router-dom";

export default function InstituteEvents() {
    const Data = [
      
        {
            venue: 'IIT Tirupati',
            title: '8th International Day of Yoga',
            description: 'IIT Tirupati Sports department and Fitness club organized 8th International Day of Yoga on 21st June 2022 in the Indoor complex. The live telecast of PM address were telecasted in the Indoor complex followed by the Yoga Instructor and his team performed the common yoga protocol from 7am to 7.45am. Our Director and Registrar delivered the Yoga day speech.',
            img: ['https://files.iittp.ac.in/pics/yogaday2022/pic1.JPG',
            'https://files.iittp.ac.in/pics/yogaday2022/pic2.JPG',
                'https://files.iittp.ac.in/pics/yogaday2022/pic3.JPG',
                'https://files.iittp.ac.in/pics/yogaday2022/pic4.JPG',
                'https://files.iittp.ac.in/pics/yogaday2022/pic5.JPG',
                'https://files.iittp.ac.in/pics/yogaday2022/pic6.JPG',
        ],
            dt: '21',
            my: 'Jun',
            category: '2022',
            link:""
        },
        {
            venue: 'IIT Tirupati',
            title: 'Tirutsava 2022',
            description: '15th - 17th Tirutsava 2022 - Annual Techno Cultural Fest, Chief Guest Shri Niranjan Kumar, Associate Vice President, Operations New-Energy, Amara Raja Batteries.',
            img: [
                'https://files.iittp.ac.in/pics/tirutsava/2022/1.jpg',
                'https://files.iittp.ac.in/pics/tirutsava/2022/2.jpg',
                'https://files.iittp.ac.in/pics/tirutsava/2022/3.jpg',
                'https://files.iittp.ac.in/pics/tirutsava/2022/4.jpg',
                'https://files.iittp.ac.in/pics/tirutsava/2022/5.jpg',
                'https://files.iittp.ac.in/pics/tirutsava/2022/6.jpg',
                'https://files.iittp.ac.in/pics/tirutsava/2022/7.jpg',
                'https://files.iittp.ac.in/pics/tirutsava/2022/8.jpg',
                'https://files.iittp.ac.in/pics/tirutsava/2022/9.jpg',
                'https://files.iittp.ac.in/pics/tirutsava/2022/10.jpg',
                'https://files.iittp.ac.in/pics/tirutsava/2022/11.jpg',
                'https://files.iittp.ac.in/pics/tirutsava/2022/12.jpg',
                'https://files.iittp.ac.in/pics/tirutsava/2022/13.jpg',
                'https://files.iittp.ac.in/pics/tirutsava/2022/14.jpg',
                'https://files.iittp.ac.in/pics/tirutsava/2022/15.jpg',
                'https://files.iittp.ac.in/pics/tirutsava/2022/16.jpg',
                'https://files.iittp.ac.in/pics/tirutsava/2022/17.jpg',
                'https://files.iittp.ac.in/pics/tirutsava/2022/18.jpg',
                'https://files.iittp.ac.in/pics/tirutsava/2022/19.jpg',
                'https://files.iittp.ac.in/pics/tirutsava/2022/20.jpg',
            ],
            dt: '15 - 17',
            my: 'April',
            category: '2022',
            link:""
        },
        {
            venue: 'IIT Tirupati',
            title: '7th Institute Day',
            description: `7th Institute Day, Chief Guest for the occasion is Shri. S. Somnath, Chairman, Indian Space Research Organisation.`,
            img: [
                "https://files.iittp.ac.in/pics/instday/2022/1.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/2.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/3.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/4.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/5.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/6.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/7.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/8.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/9.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/10.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/11.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/12.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/13.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/14.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/15.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/16.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/17.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/18.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/19.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/20.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/21.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/22.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/23.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/24.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/25.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/26.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/27.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/28.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/29.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/30.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/31.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/32.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/33.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/34.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/35.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/36.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/37.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/38.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/39.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/40.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/41.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/42.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/43.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/44.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/45.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/46.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/47.jpg",
                "https://files.iittp.ac.in/pics/instday/2022/48.jpg"
            
            ],
            dt: '6',
            my: 'Apr',
            category: '2022',
            link:"https://www.youtube.com/watch?v=prifKTRhhu0"
        },
        {
            venue: 'IIT Tirupati',
            title: 'Convocation 2021',
            description: '2nd and 3rd (Joint) Convocation 2021, Chief Guest Shri B. Santhanam CEO - Asia Pacific and India Chairman, Saint-Gobain India. ',
            img: [
                "https://files.iittp.ac.in/pics/convocation2021/1.jpeg",
                "https://files.iittp.ac.in/pics/convocation2021/2.jpeg",
                "https://files.iittp.ac.in/pics/convocation2021/3.jpeg",
                "https://files.iittp.ac.in/pics/convocation2021/4.jpeg",
                "https://files.iittp.ac.in/pics/convocation2021/5.jpeg",
                "https://files.iittp.ac.in/pics/convocation2021/6.jpeg",
                "https://files.iittp.ac.in/pics/convocation2021/7.jpeg",
                "https://files.iittp.ac.in/pics/convocation2021/8.jpeg",
                "https://files.iittp.ac.in/pics/convocation2021/group.jpeg"
            ],
            dt: '25',
            my: 'Sep',
            category: '2021',
            link:""
        },
        {
            venue: 'IIT Tirupati',
            title: '6th Institute Day',
            description: '6th Institute Day, Chief Guest Honble Vice President of India, Sri.M.Venkaiah Naidu garu.',
            img: [
                'https://files.iittp.ac.in/pics/instday/1.jpg',
                'https://files.iittp.ac.in/pics/instday/2.jpg',
                'https://files.iittp.ac.in/pics/instday/3.jpg',
                'https://files.iittp.ac.in/pics/instday/4.jpg',
                'https://files.iittp.ac.in/pics/instday/5.jpg',
                'https://files.iittp.ac.in/pics/instday/6.jpg',
                'https://files.iittp.ac.in/pics/instday/7.jpg',
                'https://files.iittp.ac.in/pics/instday/8.jpg',
            ],
            dt: '4',
            my: 'March',
            category: '2021',
            link:"https://www.youtube.com/watch?v=9O94suUqWXg&feature=youtu.be"
        },

        {
            venue: 'IIT Tirupati',
            title: 'FIT INDIA Cyclothon',
            description: 'FIT INDIA Cyclothon 2020',
            img: [
                'https://files.iittp.ac.in/pics/fitindia/cylcothon2020/1.jpg',
                'https://files.iittp.ac.in/pics/fitindia/cylcothon2020/2.jpg'
            
            ],
            dt: '20',
            my: 'Dec',
            category: '2020',
            link: ""
        },
        {
            venue: 'IIT Tirupati',
            title: 'Celebration of Constitution Day',
            description: 'Celebration of Constitution Day',
            img: [
                'https://files.iittp.ac.in/images/demo/iit/Events/2020/constday/1.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2020/constday/2.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2020/constday/3.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2020/constday/4.jpg',

            ],
            dt: '26',
            my: 'Nov',
            category: '2020',
            link: ""
        },

        {
            venue: 'IIT Tirupati',
            title: 'National Flag',
            description: 'National Flag Hoisting on 15th August by Frontline Staff',
            img: [
                'https://files.iittp.ac.in/pics/fitindia/cylcothon2020/1.jpg',
                'https://files.iittp.ac.in/pics/fitindia/cylcothon2020/2.jpg'

            ],
            dt: '15',
            my: 'Aug',
            category: '2020',
            link: ""
        } ,

        {
            venue: 'IIT Tirupati',
            title: 'International Womens Day ',
            description: 'International Womens Day celebrations and Inaugural ceremony of MEDHA - Women s Forum of IIT Tirupati Chief Guest: Prof. Duvvuru Jamuna, Vice-Chancellor, Sri Padmavati Mahila Visvavidyalayam, Tirupati and guestspeaker: Dr. Vasudha Katju, Faculty Associate, KREA University, Sri City',
            img: [
                'https://files.iittp.ac.in/images/demo/iit/Events/2020/womensday/1.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2020/womensday/2.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2020/womensday/3.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2020/womensday/4.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2020/womensday/5.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2020/womensday/6.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2020/womensday/7.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2020/womensday/8.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2020/womensday/9.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2020/womensday/10.jpg',
            ],
            dt: '12',
            my: 'March',
            category: '2020',
            link: ""
        }

        ,

        {
            venue: 'IIT Tirupati',
            title: 'Fit India Fitness Club',
            description: 'Fit India Fitness Club - Inauguration Ceremony',
            img: [
                'https://files.iittp.ac.in/pics/fitindia/inauguration/1.jpg',
                'https://files.iittp.ac.in/pics/fitindia/inauguration/2.jpg',
                'https://files.iittp.ac.in/pics/fitindia/inauguration/3.jpg',
                'https://files.iittp.ac.in/pics/fitindia/inauguration/4.jpg',
                'https://files.iittp.ac.in/pics/fitindia/inauguration/5.jpg',

            ],
            dt: '22',
            my: 'Jan',
            category: '2020',
            link: ""
        },


        ,

        {
            venue: 'IIT Tirupati',
            title: 'First Convocation - 2019 ',
            description: 'First Convocation - 2019 at Yerpedu Campus ',
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/convocation/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/convocation/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/convocation/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/convocation/4.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/convocation/5.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/convocation/10.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/convocation/15.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/convocation/6.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/convocation/7.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/convocation/8.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/convocation/9.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/convocation/11.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/convocation/12.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/convocation/13.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/convocation/14.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/convocation/16.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/convocation/17.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/convocation/18.jpg"

            ],
            dt: '13',
            my: 'Aug',
            category: '2019',
            link: ""
        },

        {
            venue: 'IIT Tirupati',
            title: '7K Walk - 2019 at Yerpedu Campus',
            description: '7K Walk - 2019 at Yerpedu Campus',
            img: [
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/7krun/1.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/7krun/2.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/7krun/3.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/7krun/4.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/7krun/5.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/7krun/6.jpg',

            ],
            dt: '28',
            my: 'Jul',
            category: '2019',
            link: ""
        },

        {
            venue: 'IIT Tirupati',
            title: 'Orientation Program - 2019 ',
            description: 'Orientation Program - 2019 ',
            img: [
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/orientation/1.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/orientation/2.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/orientation/3.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/orientation/4.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/orientation/5.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/orientation/6.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/orientation/7.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/orientation/8.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/orientation/9.jpg',

            ],
            dt: '25',
            my: 'Jul',
            category: '2019',
            link: ""
        },

        {
            venue: 'IIT Tirupati',
            title: 'International Yoga Day',
            description: 'International Yoga Day - Celebrations ',
            img: [
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/yoga/1.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/yoga/2.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/yoga/3.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/yoga/4.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/yoga/5.jpg',

            ],
            dt: '21',
            my: 'Jun',
            category: '2019',
            link: ""
        },

        {
            venue: 'IIT Tirupati',
            title: '70th Republic Day Celebrations',
            description: '70th Republic Day Celebrations at Yerpedu Campus',
            img: [
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/republicday/1.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/republicday/2.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/republicday/3.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/republicday/4.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/republicday/5.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/republicday/6.jpg',

            ],
            dt: '26',
            my: 'Jan',
            category: '2019',
            link: ""
        }
        ,

        {
            venue: 'IIT Tirupati',
            title: '72nd Independence Day',
            description: '72nd Independence Day Celebrations at Permanent Campus',
            img: [
                'https://files.iittp.ac.in/images/demo/iit/Events/2018/independenceday/1.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2018/independenceday/2.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2018/independenceday/3.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2018/independenceday/4.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2018/independenceday/5.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2018/independenceday/6.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2018/independenceday/7.jpg',

            ],
            dt: '15',
            my: 'Augest',
            category: '2018',
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "7K Walk at Permanent Campus",
            description: "7K Walk at Permanent Campus.",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/FUNRUN/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/FUNRUN/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/FUNRUN/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/FUNRUN/4.jpg"
            ],
            dt: "12",
            my: "August",
            category: "2018",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "Orientation Program for First Year Students at Transit Campus.",
            description: "Orientation Program for First Year Students at Transit Campus.",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Orientationprogramme-Aug2018/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Orientationprogramme-Aug2018/11.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Orientationprogramme-Aug2018/4.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Orientationprogramme-Aug2018/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Orientationprogramme-Aug2018/8.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Orientationprogramme-Aug2018/6.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Orientationprogramme-Aug2018/9.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Orientationprogramme-Aug2018/10.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Orientationprogramme-Aug2018/7.jpg"
            ],
            dt: "08",
            my: "August",
            category: "2018",
            link: ""
        },

        {
            venue: "Permanent Campus",
            title: "Pooja at Permanent Campus.",
            description: "Pooja at Permanent Campus.",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/pooja/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/pooja/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/pooja/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/pooja/4.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/pooja/5.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/pooja/6.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/pooja/7.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/pooja/8.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/pooja/9.jpg"
            ],
            dt: "06",
            my: "August",
            category: "2018",
            link: ""
        },
        
            {
                venue: "",
                title: "International Yoga Day - Celebrations",
                description: "International Yoga Day - Celebrations",
                img: [
                    "https://files.iittp.ac.in/images/demo/iit/Events/2018/yoga/1.jpg",
                    "https://files.iittp.ac.in/images/demo/iit/Events/2018/yoga/2.jpg",
                    "https://files.iittp.ac.in/images/demo/iit/Events/2018/yoga/3.jpg",
                    "https://files.iittp.ac.in/images/demo/iit/Events/2018/yoga/4.jpg",
                    "https://files.iittp.ac.in/images/demo/iit/Events/2018/yoga/5.jpg",
                    "https://files.iittp.ac.in/images/demo/iit/Events/2018/yoga/6.jpg",
                    "https://files.iittp.ac.in/images/demo/iit/Events/2018/yoga/7.jpg"
                ],
                dt: "21",
                my: "June",
                category: "2018",
                link: ""
            },
        {
            venue: "",
            title: "3rd Institute Day - Chief Guest Sri A.K.Singhal, IAS, Executive Officer of TTD, Tirumala",
            description: "3rd Institute Day - Chief Guest Sri A.K.Singhal, IAS, Executive Officer of TTD, Tirumala",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/4.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/5.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/6.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/7.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/8.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/9.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/10.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/11.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/13.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/14.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/15.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/16.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/17.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/18.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/19.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/20.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/21.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/22.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/23.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/24.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/25.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/InstituteDay/26.jpg"
            ],
            dt: "04",
            my: "Apr",
            category: "2018",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "Tirutsava - First Techno Cultural Festival",
            description: "Description of the event goes here.",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Tirutsava/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Tirutsava/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Tirutsava/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Tirutsava/4.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Tirutsava/5.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Tirutsava/6.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Tirutsava/7.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Tirutsava/8.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Tirutsava/9.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Tirutsava/10.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Tirutsava/11.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Tirutsava/12.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Tirutsava/12.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Tirutsava/13.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Tirutsava/14.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Tirutsava/15.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Tirutsava/16.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Tirutsava/17.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Tirutsava/18.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Tirutsava/19.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/Tirutsava/20.jpg",
            
            ],
            dt: "02-04",
            my: "Mar",
            category: "2018",
            link: ""
        },


        {
            venue: "IIT Tirupati",
            title: "69th Republic Day Celebrations",
            description: "Description of the event goes here.",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/RepublicDay-Jan26/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/RepublicDay-Jan26/15.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/RepublicDay-Jan26/4.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/RepublicDay-Jan26/5.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/RepublicDay-Jan26/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/RepublicDay-Jan26/6.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/RepublicDay-Jan26/7.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/RepublicDay-Jan26/8.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/RepublicDay-Jan26/9.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/RepublicDay-Jan26/10.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/RepublicDay-Jan26/11.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/RepublicDay-Jan26/12.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/RepublicDay-Jan26/13.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/RepublicDay-Jan26/14.jpg"

            ],
            dt: "26",
            my: "Jan",
            category: "2018",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "Run For Unity",
            description: "Run For Unity event at IIT Tirupati",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/UnityRun/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/UnityRun/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/UnityRun/3.jpg"
            ],
            dt: "05",
            my: "Nov",
           category: "2017",
            link: "" 
        },

        {
            venue: "IIT Tirupati",
            title: "Vigilance Awarness Week - Special Lecture by Mr. A. Ravi Krishna, IPS, Chief Vigilance and Security Officer, Tirumala Tirupati Devasthanams (TTD)",
            description: "Vigilance Awarness Week - Special Lecture by Mr. A. Ravi Krishna, IPS, Chief Vigilance and Security Officer, Tirumala Tirupati Devasthanams (TTD)",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/Vigilanceweek/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Vigilanceweek/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Vigilanceweek/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Vigilanceweek/4.jpg"
            ],
            dt: "03",
            my: "Nov",
           category: "2017",
            link: ""
        },
        {
            venue: "IIT Tirupati",
            title: "Mini CEA Event",
            description: "Mini CEA Event by Civil Engineering Association at IIT Tirupati for students of Civil Engineering Branch.",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/MiniCEA/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/MiniCEA/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/MiniCEA/4.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/MiniCEA/5.jpg"
            ],
            dt: "07",
            my: "Oct",
           category: "2017",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "Teacher's Day Celebrations - Chief Guest Prof. P. S. Rao, Former Dean, IIT Madras",
            description: "Teacher's Day Celebrations - Chief Guest Prof. P. S. Rao, Former Dean, IIT Madras",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/Teachersday[Sep5-2017]/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Teachersday[Sep5-2017]/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Teachersday[Sep5-2017]/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Teachersday[Sep5-2017]/4.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Teachersday[Sep5-2017]/5.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Teachersday[Sep5-2017]/6.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Teachersday[Sep5-2017]/7.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Teachersday[Sep5-2017]/8.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Teachersday[Sep5-2017]/9.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Teachersday[Sep5-2017]/10.jpg"
            ],
            dt: "05",
            my: "Sep",
           category: "2017",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "7K - FUN RUN",
            description: "7K - FUN RUN by 2017 Batch Students at IIT Tirupati Permanent Campus",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/7k-FunRUN[Aug5]/1.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/7k-FunRUN[Aug5]/3.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/7k-FunRUN[Aug5]/4.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/7k-FunRUN[Aug5]/5.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/7k-FunRUN[Aug5]/6.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/7k-FunRUN[Aug5]/7.JPG"
            ],
            dt: "05",
            my: "Aug",
           category: "2017",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "Third Batch Orientation Programme",
            description: "Third Batch Orientation Programme.",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/ThirdBatchOrientationJuly31/1.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/ThirdBatchOrientationJuly31/3.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/ThirdBatchOrientationJuly31/4.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/ThirdBatchOrientationJuly31/5.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/ThirdBatchOrientationJuly31/6.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/ThirdBatchOrientationJuly31/7.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/ThirdBatchOrientationJuly31/8.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/ThirdBatchOrientationJuly31/9.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/ThirdBatchOrientationJuly31/10.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/ThirdBatchOrientationJuly31/11.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/ThirdBatchOrientationJuly31/12.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/ThirdBatchOrientationJuly31/13.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/ThirdBatchOrientationJuly31/14.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/ThirdBatchOrientationJuly31/15.JPG"
            ],
            dt: "31",
            my: "July",
           category: "2017",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "International Yoga Day Celebrations - Talk on Yoga and Yoga Demonstrations by Mr. Jampala Srinivasa Rao",
            description: "International Yoga Day Celebrations - Talk on Yoga and Yoga Demonstrations by Mr. Jampala Srinivasa Rao.",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/yoga(21Jun2017)/1.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/yoga(21Jun2017)/2.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/yoga(21Jun2017)/3.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/yoga(21Jun2017)/4.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/yoga(21Jun2017)/5.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/yoga(21Jun2017)/6.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/yoga(21Jun2017)/7.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/yoga(21Jun2017)/8.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/yoga(21Jun2017)/9.JPG"
            ],
            dt: "21",
            my: "June",
           category: "2017",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "Second Institute Day - Chief Guest Prof. V.S.Raju, Former Director IIT Delhi.",
            description: "Second Institute Day - Chief Guest Prof. V.S.Raju, Former Director IIT Delhi.",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/secondInstituteday/1.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/secondInstituteday/2.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/secondInstituteday/3.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/secondInstituteday/4.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/secondInstituteday/5.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/secondInstituteday/6.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/secondInstituteday/7.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/secondInstituteday/8.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/secondInstituteday/9.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/secondInstituteday/10.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/secondInstituteday/11.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/secondInstituteday/12.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/secondInstituteday/13.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/secondInstituteday/14.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/secondInstituteday/15.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/secondInstituteday/16.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/secondInstituteday/17.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/secondInstituteday/18.JPG"
            ],
            dt: "07",
            my: "April",
           category: "2017",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "ANFANG -Tech Fest",
            description: "ANFANG -Tech Fest",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/Anfang/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Anfang/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Anfang/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Anfang/5.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Anfang/6.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Anfang/7.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Anfang/9.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Anfang/10.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Anfang/11.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Anfang/12.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Anfang/13.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Anfang/14.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Anfang/15.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Anfang/16.jpg"
            ],
            dt: "25-26",
            my: "March",
           category: "2017",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "ART Exhibition",
            description: "ART Exhibition",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/ArtExhibition/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/ArtExhibition/2.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/ArtExhibition/3.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/ArtExhibition/4.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/ArtExhibition/5.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/ArtExhibition/6.JPG"
            ],
            dt: "05",
            my: "April",
           category: "2017",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "Republic Day",
            description: "Republic Day",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/republicday/1.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/republicday/2.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/republicday/3.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/republicday/4.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/republicday/5.JPG"
            ],
            dt: "26",
            my: "January",
           category: "2017",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "Astronomy Workshop",
            description: "Astronomy Workshop",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/Astro/1.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/Astro/2.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/Astro/3.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/Astro/4.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Astro/5.jpg"
            ],
            dt: "27-29",
            my: "January",
           category: "2017",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "7K RUN",
            description: "7K RUN",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/7KRUN/1.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/7KRUN/2.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/7KRUN/3.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/7KRUN/4.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/7KRUN/5.JPG"
            ],
            dt: "28",
            my: "January",
           category: "2017",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "Dr. K.N Satyanarayana as Director - Press Conference",
            description: "Dr. K.N Satyanarayana as Director - Press Conference",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/DirectorsSpeech/1.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/DirectorsSpeech/2.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/DirectorsSpeech/3.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/DirectorsSpeech/4.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/DirectorsSpeech/5.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/DirectorsSpeech/6.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/DirectorsSpeech/7.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/DirectorsSpeech/8.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/DirectorsSpeech/9.JPG"
            ],
            dt: "19-20",
            my: "January",
           category: "2017",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "President Addresses to Faculties and Students through VC",
            description: "President Addresses to Faculties and Students through VC.",
            img: [],
            dt: "10",
            my: "January",
           category: "2017",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "R.Subramanyam IAS , Additional Secretary MHRD - Visit",
            description: "Additional Secretary (TE), MHRD has visited IIT Tirupati permanent campus on 24-12-2016 along with Prof. K.N. Satyanarayana the then Professor In-charge and District Collector to discuss the status of the permanent campus related matters.",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/R.SubramanyamVisit/1.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/R.SubramanyamVisit/2.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/R.SubramanyamVisit/3.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/R.SubramanyamVisit/4.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/R.SubramanyamVisit/5.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/R.SubramanyamVisit/6.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/R.SubramanyamVisit/7.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/R.SubramanyamVisit/8.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/R.SubramanyamVisit/9.JPG"
            ],
            dt: "24",
            my: "December",
           category: "2016",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "Robokart Workshop",
            description: "Robokart Workshop",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/Robokart/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Robokart/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Robokart/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Robokart/4.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Robokart/5.jpg"
            ],
            dt: "24-25",
            my: "September",
           category: "2016",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "Hon’ble Minister Prakash Javdekar -Visit",
            description: "Mr. Prakash Javdekar, Minister of Human Resource Development, Govt of India has visited IIT Tirupati on 12th September, 2016 and addressed the Faculty of IIT Tirupati and IISER Tirupati. He interacted with the Faculty and invited suggestions on “ How to build a world class research Institute”.",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/MinisterJavedkarVisit/1.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/MinisterJavedkarVisit/4.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/MinisterJavedkarVisit/5.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/MinisterJavedkarVisit/6.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/MinisterJavedkarVisit/7.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/MinisterJavedkarVisit/8.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/MinisterJavedkarVisit/9.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/MinisterJavedkarVisit/10.JPG"
            ],
            dt: "12",
            my: "September",
           category: "2016",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "Independence Day Celebrations",
            description: "Celebrations",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/Indday/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Indday/2.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/Indday/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Indday/4.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Indday/5.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Indday/6.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Indday/7.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Indday/8.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Indday/9.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Indday/17.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/Indday/10.JPG"
            ],
            dt: "15",
            my: "August",
           category: "2016",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "Teachers Day Celebration & Canteen Inauguration",
            description: "Teachers Day Celebration & Canteen Inauguration - Chief Guest Prof. M.S.Ananth Former Director, IIT Madras",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/TdayAndCanteenInaugration/1.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/TdayAndCanteenInaugration/2.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/TdayAndCanteenInaugration/3.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/TdayAndCanteenInaugration/4.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/TdayAndCanteenInaugration/5.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/TdayAndCanteenInaugration/6.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/TdayAndCanteenInaugration/7.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/TdayAndCanteenInaugration/8.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/TdayAndCanteenInaugration/9.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/TdayAndCanteenInaugration/10.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/TdayAndCanteenInaugration/11.JPG"
            ],
            dt: "05",
            my: "September",
           category: "2016",
            link: ""
        },


        {
            venue: "IIT Tirupati",
            title: "Orientation",
            description: "Orientation - Second Batch",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/SecondBatchOrientation/1.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/SecondBatchOrientation/2.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/SecondBatchOrientation/3.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/SecondBatchOrientation/4.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/SecondBatchOrientation/5.JPG"
            ],
            dt: "01",
            my: "August",
           category: "2016",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "First Institute Day",
            description: "First Institute Day",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/Instday1/1.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/Instday1/4.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/Instday1/5.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/Instday1/6.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/Instday1/7.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/Instday1/15.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/Instday1/17.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/Instday1/20.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/Instday1/21.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/Instday1/22.JPG"
            ],
            dt: "12",
            my: "April",
           category: "2016",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "Foundation Stone",
            description: "Laying of foundation stone by the HRD Minister Ms Smriti Zubin Irani in the presence of Mr. Chandrababu Naidu, the Chief Minister of Andhra Pradesh, Mr. Venkaiah Naidu, the Union Minister for Urban Development, Mr. Y.S. Chowdary, the Minister of State, Ministry of Science and Technology and Mr. Ganta Srinivasa Rao, the Minister for Human Resource Management, Andhra Pradesh",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/FoundationStone/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/FoundationStone/2.jpg"
            ],
            dt: "28",
            my: "March",
           category: "2015",
            link: ""
        },

        {
            venue: "IIT Tirupati",
            title: "Academic Orientation Programme",
            description: "The orientation programme of the pioneer batch took place on 5 August 2015. The Honourable Minister of HRD, GoI, Ms Smriti Zubin Irani welcomed and addressed the pioneer batch through video conferencing. Mr. Ganta Srinivasa Rao (HRD Minister, Government of Andhra Pradesh), Dr. Sambasiva Rao, IAS (Executive Officer, TTD), Mr. Siddharth Jain, IAS (Collector, Chittoor District), Prof. Bhaskar Ramamurthi (Director, IIT Madras) and a number of dignitaries from the Government of Andhra Pradesh graced the inaugural programme and addressed the students.",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/FoundationStone/7.png",
                "https://files.iittp.ac.in/images/demo/iit/Events/FoundationStone/8.png",
                "https://files.iittp.ac.in/images/demo/iit/Events/FoundationStone/9.png",
                "https://files.iittp.ac.in/images/demo/iit/Events/FoundationStone/10.png"
            ],
            dt: "05",
            my: "August",
           category: "2015",
            link: ""
        }
























        

    ];

    const [activeButton, setActiveButton] = useState("View All");
    const [current, setcurrent] = useState(Data);

    const Filter = (category) => {
        setActiveButton(category);
        const arr = [];
        if (category === "View All") {
            setcurrent(Data);
        } else {
            Data.map((item) => {
                if (item.category === category) {
                    arr.push(item);
                }
            });
            setcurrent(arr);
        }
    };

    function chunkArray(array, chunkSize) {
        const chunkedArray = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            chunkedArray.push(array.slice(i, i + chunkSize));
        }
        return chunkedArray;
    }

    const [expandedDescriptions, setExpandedDescriptions] = useState({});

    // Function to toggle the description expansion
    const toggleDescriptionExpansion = (index) => {
        setExpandedDescriptions({
            ...expandedDescriptions, [index]: !expandedDescriptions[index],
        });
    };

    return (<div className="institute-events">
        <Header/>
        <Breadcrumb subtitle={"Institute Events"} title={"Home"}/>

        <section className="project-detail">
            <div className="container">
                <div className="section-title center-align mb-50 wow fadeInDown animated"
                     data-animation="fadeInDown" data-delay=".4s">
                    <h5><i className="fal fa-calendar"/> Events</h5>
                    <h2>Institute Events</h2>
                </div>
                <Row>
                    <Col md={4} className="c-left">
                        <LeftEvents activeIndex={4}/>
                    </Col>

                    <Col md={8} className="c-left">
                        <div className="row align-items-end">
                            <div className="col-lg-12">
                                <div className="my-masonry text-center mb-50 wow fadeInRight animated"
                                     data-animation="fadeInRight" data-delay=".4s">
                                    <div className="button-group filter-button-group ">
                                        <button className={`${activeButton === "View All" ? "active" : ""}`}
                                                data-filter="*" onClick={() => Filter("View All")}> View All
                                        </button>
                                        <button className={`${activeButton === "2022" ? "active" : ""}`}
                                                data-filter=".2019" onClick={() => Filter("2022")}>2022
                                        </button>
                                        <button className={`${activeButton === "2021" ? "active" : ""}`}
                                                data-filter=".2019" onClick={() => Filter("2021")}>2021
                                        </button>
                                        <button className={`${activeButton === "2020" ? "active" : ""}`}
                                                data-filter=".2019" onClick={() => Filter("2020")}>2020
                                        </button>
                                        <button className={`${activeButton === "2019" ? "active" : ""}`}
                                                data-filter=".2019" onClick={() => Filter("2019")}>2019
                                        </button>
                                        <button className={`${activeButton === "2018" ? "active" : ""}`}
                                                data-filter=".2018" onClick={() => Filter("2018")}>2018
                                        </button>
                                        <button className={`${activeButton === "2017" ? "active" : ""}`}
                                                data-filter=".2017" onClick={() => Filter("2017")}>2017
                                        </button>
                                        <button className={`${activeButton === "2016" ? "active" : ""}`}
                                                data-filter=".2016" onClick={() => Filter("2016")}>2016
                                        </button>
                                        <button className={`${activeButton === "2015" ? "active" : ""}`}
                                                data-filter=".2015" onClick={() => Filter("2015")}>2015
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {chunkArray(current, 2).map((row, rowIndex) => (<Row key={rowIndex}>
                            {row.map((event, index) => (
                                <Col key={index} lg={6} md={6} sm={12} className="wow fadeInUp animated"
                                     data-animation="fadeInUp" data-delay=".4s">
                                    <div className="event-item mb-30 hover-zoomin">
                                        <div className="thumb">
                                            <Carousel showArrows={true} showThumbs={false} dynamicHeight={false}
                                                      selectedItem={0}>
                                                {event.img.map((image, imgIndex) => (<div key={imgIndex}>
                                                    <img src={image} alt={`event-img-${imgIndex}`}/>
                                                </div>))}
                                            </Carousel>
                                        </div>
                                        <div className="event-content">
                                            <div className="date">
                                                <strong>{event.dt}</strong> {event.my}
                                            </div>
                                            <h3 style={{minHeight: "87px"}}>
                                                <Link to={event.link}> {event.title}</Link>
                                            </h3>
                                            <p>
                                                {expandedDescriptions[index] ? event.description : event.description.split(' ').slice(0, 20).join(' ')}
                                                {event.description.split(' ').length > 20 && (
                                                    <span className="read-more">
                                                        <button style={{
                                                            textDecoration: "underline",
                                                            color: "#007bff",
                                                            cursor: 'pointer',
                                                            padding: '0',
                                                            border: 'none',
                                                            background: 'none'
                                                        }}
                                                                onClick={() => toggleDescriptionExpansion(index)}>
                                                            {expandedDescriptions[index] ? " Show Less" : "...Show More"}
                                                        </button>
                                                    </span>)}
                                            </p>
                                            <div className="time">
                                                {event.duration} <i className="fal fa-long-arrow-right"/>{" "}
                                                <strong>{event.venue}</strong>
                                            </div>
                                        </div>
                                    </div>
                                </Col>))}
                        </Row>))}
                    </Col>
                </Row>
            </div>
        </section>
    </div>);
}
